module.exports = __webpack_public_path__ + "img/Nicht_unterkellert.c6e6b03f.svg";